import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import TitledTextField from '../../core/TitledTextField';
import { MAX_PROJECT_DESC_LENGTH, MAX_PROJECT_TITLE_LENGTH } from '../../core/utils/constants';
import { globalStyles as styles } from '../style/gstheme';

function EnterProjectDetails(props) {

    return (
        <form autoComplete="off" noValidate="novalidate">
            <TitledTextField
                dataTest="enter-project-title"
                margin={false}
                name="title"
                title="Title"
                autoFocus={true}
                showLang={false}
                lang={props.lang}
                required={props.mandatory}
                text={props.title}
                placeholder="Enter project title"
                maxLength={MAX_PROJECT_TITLE_LENGTH}
                onChange={props.handleTitleChange} />
            <TitledTextField
                dataTest="enter-project-description"
                margin={true}
                disabled={props.mandatory === false && props.title === ""}
                name="description"
                title="Description"
                showLang={false}
                lang={props.lang}
                autoFocus={false}
                text={props.description}
                placeholder="Enter project description"
                maxLength={MAX_PROJECT_DESC_LENGTH}
                onChange={props.handleDescChange} />
        </form>
    );
}

export default withStyles(styles)(EnterProjectDetails);